import React from 'react'

interface ConstituentProcessIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ConstituentProcessIcon: React.FC<ConstituentProcessIconProps> = ({
  color = '#000',
  gradient,
  width = 22,
  height = 18,
  alt = 'Constituent process icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 22 18'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M11 4.54a1.645 1.645 0 100-3.29 1.645 1.645 0 000 3.29zm0 1.25A2.895 2.895 0 1011 0a2.895 2.895 0 000 5.79zM18.113 6.67a.959.959 0 100-1.918.959.959 0 000 1.917zm0 1.25a2.209 2.209 0 100-4.418 2.209 2.209 0 000 4.417zM3.978 6.67a.959.959 0 100-1.918.959.959 0 000 1.917zm0 1.25a2.209 2.209 0 100-4.418 2.209 2.209 0 000 4.417zM14.639 12.404c.007-.098.01-.197.01-.296 0-2.19-1.673-3.858-3.608-3.858-1.936 0-3.61 1.668-3.61 3.857 0 .1.004.2.011.297.007.094.003.187-.01.276v4.07h7.217v-4.07a1.256 1.256 0 01-.01-.276zm1.247.089c0 .004.003.007.007.007.003 0 .006.003.006.007V17a1 1 0 01-1 1H7.183a1 1 0 01-1-1v-4.493c0-.004.003-.007.006-.007a.007.007 0 00.007-.007 5.424 5.424 0 01-.007-.658C6.323 9.14 8.444 7 11.041 7c2.596 0 4.717 2.14 4.852 4.835a5.364 5.364 0 01-.007.658z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M6.677 9.829a4.179 4.179 0 00-6.665 3.665.006.006 0 01-.006.006.006.006 0 00-.006.006V17a1 1 0 001 1h6.358a.999.999 0 00.823-.432h-.995a1 1 0 01-.984-.818H1.25v-3.083c.012-.086.015-.175.008-.266a2.929 2.929 0 015-2.284c.08-.455.223-.887.419-1.288zM15.399 10.041A3.852 3.852 0 0118.025 9c2.124 0 3.859 1.752 3.97 3.956a4.47 4.47 0 01-.006.538c0 .003.002.006.005.006s.006.002.006.006V17a1 1 0 01-1 1h-5.95c-.034 0-.066-.001-.098-.004a1 1 0 00.863-.991v-.255h4.935v-3.086a1.264 1.264 0 01-.008-.258c.005-.075.008-.15.008-.227 0-1.677-1.278-2.929-2.726-2.929-.903 0-1.74.488-2.243 1.263a5.276 5.276 0 00-.382-1.472z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default ConstituentProcessIcon
